import * as localeUtils from './locale'; // re-import utils to allow mocking in tests

const DEFAULT_LANGUAGE = 'en';
const ES_US_LOCALE = 'es-US';
const ES_MX_LOCALE = 'es-MX';
// See https://issues.hubspotcentral.com/browse/PAYSUP-814 for why we have to account for es-419
const ES_LATAM_LOCALE = 'es-419';
export const normalizeLocale = locale => {
  try {
    return Intl.getCanonicalLocales(locale)[0];
  } catch (_unused) {
    return DEFAULT_LANGUAGE;
  }
};

// Copied from https://git.hubteam.com/HubSpot/I18n/blob/4bc9ae0ed020b4a155887adc48d4a414bc097729/static/js/init/providers/createPublicI18nProvider.ts#L21
export const getBrowserLocale = () => {
  let locale = DEFAULT_LANGUAGE;
  if (navigator && navigator.languages && navigator.languages[0]) {
    locale = navigator.languages[0];
  } else if (navigator && navigator.language) {
    locale = navigator.language;
  }
  return normalizeLocale(locale);
};

// Overrides certain locale values since they're not supported by our i18n setup
// Full context here: https://hubspot.slack.com/archives/C6PL2HX0C/p1699986304019579
export const setAppLocale = I18nPublicProvider => {
  let locale = localeUtils.getBrowserLocale();
  if (locale === ES_US_LOCALE || locale === ES_LATAM_LOCALE) {
    locale = ES_MX_LOCALE;
  }
  I18nPublicProvider.setLocale({
    locale,
    langEnabled: true
  });
};